// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3JgRf","logo":"Header_logo__3ZAa4","emergency":"Header_emergency__HRyVt","emergencyPhone":"Header_emergencyPhone__32WT3"};